// extracted by mini-css-extract-plugin
export default {"button":"Button_button__Wx62k","button--variant-primary":"Button_button--variant-primary__njaR1","button--variant-secondary":"Button_button--variant-secondary__AWo8i"};